import './styles.scss';
import React, {useState} from "react";
import LinkButton from "../../../button-link";
import * as Constants from "../../../../constants";
import {Link} from "react-router-dom";

interface IProps {
  defaultExpanded?: boolean,
  text: string,
  label: string,
  link: string
}
const MIN_LINES_EXPAND: number = 5;

const ExpandField = (props: IProps):JSX.Element => {
  const {
    defaultExpanded,
    text,
    label,
    link
  } = props;

  const [expanded, setExpanded] = useState<boolean>(defaultExpanded);
  const tempElem: HTMLDivElement = document.createElement('div');
  tempElem.textContent = text;
  document.body.appendChild(tempElem);
  const numOfLines: number =  Math.round(tempElem.clientHeight/19.2); // line height of 1.2 * 16 = 19.2
  tempElem.remove();

  let elem: JSX.Element = <>
    {!link &&
      <span className={'one-line ' + ((numOfLines < MIN_LINES_EXPAND) || expanded ? '':'max-lines lines-4')} dangerouslySetInnerHTML={{__html: text}}/>}

    {link && <Link
          to={link}>
          <div className={(numOfLines < MIN_LINES_EXPAND) || expanded ? '':'max-lines lines-4'} dangerouslySetInnerHTML={{__html: text}}/>
        </Link>
      }

    {(numOfLines >= MIN_LINES_EXPAND) &&
      <div className={'position-relative'}>
        <LinkButton
          label={expanded ? 'Hide Full ' + label : 'Show Full ' + label}
          linkUpDownArrow={expanded ? Constants.UP : Constants.DOWN}
          clickFunc={()=>setExpanded(!expanded)}
        />
      </div>
    }
  </>

  return (
    <span className={'expand-field'}>
      {elem}
    </span>
  )
}

export default ExpandField;
